import { Link } from 'react-router-dom';
import '../../css/MatchesLeague.css';
import premier from "../../assets/premierleague.png";

const SoccerLeagues = () => {
    return (
        <main id="matches-league-content">
            <h2 id="quest">Which League's Matches Would You Like To See?</h2>
            <Link to="/sports/soccer/premier-league">
                <section id="premier-section">
                    <div id="premier-container">
                        <img id="premier-img" src={premier} alt="Premier League" />
                    </div>
                </section> 
            </Link>
        </main>
    );
};

export default SoccerLeagues;